import { ILocalizationItem } from "@multiweb/types/contracts/localizations";

/**
 * Lokální úožiště lokalizací.
 */
export interface ILocalizationStorage {

    /**
     * Uloží lokalizase do lokálního úložiště
     * @param language Kód jazyka lokalizací (např. 'EN' nebo 'CZ')
     * @param data Data lokalizací k uložení
     */
    saveLocalizations(language: string, data: readonly ILocalizationItem[]): Promise<void>;

    /**
     * Načte lokalizase z lokálního úložiště
     * @param language Kód jazyka lokalizací (např. 'EN' nebo 'CZ')
     * @param locKeys Lokalizační klíče k načtení
     */
    getLocalizations(language: string, locKeys: readonly string[]): Promise<readonly ILocalizationItem[]>;
}
